import React, { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("GB_User_Data")));

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const phone = params.get("Phonenumber");
  const idprovider = parseInt(params.get("IDPaymentProvider"), 10);
  const isFree = params.get("free") === "true";

  if (isFree) {
    const freeUser = {
      AppHashKey: "",
      Country: "",
      Description: "Subscription Active",
      IDPaymentProvider: 2,
      PLMN: "",
      PackageName: "",
      RegistrationID: "",
      ShowPP: true,
      ShowTC: true,
      Status: 0,
      billingChannelId: -1,
      showMyAccountDetails: false,
      showUnsub: false,
      isFree: true,
    };

    localStorage.setItem("GB_User_Data", JSON.stringify(freeUser));
    setUser(freeUser);
    setChecking(false);
    return;
  }

  if (phone) {
    const userFromParams = {
      AppHashKey: params.get("Key") || "",
      Country: params.get("Country") || "",
      Description: "Subscription Active",
      IDPaymentProvider: idprovider || 0,
      PLMN: "",
      PackageName: "",
      RegistrationID: "",
      ShowPP: (params.get("ShowPP") || "").toLowerCase() === "true",
      ShowTC: (params.get("ShowTC") || "").toLowerCase() === "true",
      Status: 0,
      billingChannelId: parseInt(params.get("billingChannelId"), 10) || -1,
      showMyAccountDetails: (params.get("showMyAccountDetails") || "").toLowerCase() === "true",
      showUnsub: (params.get("showUnsub") || "").toLowerCase() === "true",
      isFree: false,
      Phone: phone,
    };

    localStorage.setItem("GB_User_Data", JSON.stringify(userFromParams));
    setUser(userFromParams);
    setChecking(false);
  } else {
    setChecking(false);
  }

}, []);


  if (checking) return null; // Optionally return a spinner or loading state

  const isPublicPath = location.pathname === "/" || location.pathname === "/games";
  const isDashboardPath = location.pathname.startsWith("/dashboard");

  if (user && isPublicPath) {
    return <Navigate to="/dashboard/home" replace />;
  }

  if (!user && isDashboardPath) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthGuard;
